import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from '@mui/material';
import { createGetRangeColorFn, generateColorRange, rangify } from '../../../cosmetics/DataTheming/metricRanges';
export const metricAttributeKeys = ['power', 'rssi', 'sf', 'snr', 'esp', 'dropped'];
/**
 * Developed from the IBM Design Library colour palette for accessiblility for colour-blindness:
 * https://www.ibm.com/design/language/color/#the-palette
 */
export const rangeColors = {
    power: generateColorRange(rangify([8, 11, 14, 17, 20]), '#F1948A', '#A2D39C'),
    rssi: generateColorRange(rangify([-130, -125, -120, -115, -110, -105, -100, -95, -90, -85]), '#001d66', '#648fff', 'white'),
    dr: generateColorRange(rangify([5, 4, 3, 2, 1, 0], false), '#6344ee', '#050213', undefined, undefined, false),
    sf: generateColorRange(rangify([7, 8, 9, 10, 11, 12]), '#8a73f2', '#120746'),
    snr: generateColorRange(rangify([-15, -12, -9, -6, -3, 0, 3, 6, 9, 12, 15]), '#4d1d00', '#ffa166'),
    esp: generateColorRange(rangify([-130, -125, -120, -115, -110, -105, -100, -95, -90, -85]), '#0d3640', '#00ffff'),
    consumedAirtimeSecs: generateColorRange(rangify([0, 0.05, 0.1, 0.5, 1.0, 5.0]), '#420a25', '#ea7bb1', 'white'),
    dropped: generateColorRange(rangify([1, 10, 100]), '#000000', '#FF0000', 'white'),
};
export const getRangeColor = createGetRangeColorFn(rangeColors);
export const getRangeText = (lo, hi) => {
    return (_jsxs(Stack, { direction: "row", children: [_jsx(Box, { sx: { width: '33%', textAlign: 'center' }, children: `${lo === -Infinity ? '-\u221E' : lo}` }), _jsx(Box, { sx: { width: '33%', textAlign: 'center' }, children: "-" }), _jsx(Box, { sx: { width: '33%', textAlign: 'center' }, children: `${hi === Infinity ? '\u221E' : hi}` })] }));
};
